import vue from 'vue'
import VueRouter from 'vue-router';
vue.use(VueRouter);

import Login from '../page/Login'
import Index from '../page/Index'
import Console from '../page/Console'
// msg
import Send from '../page/msg/Send'

//ticket 票券管理
import manage from '../page/ticket/manage'
import manageList from '../page/ticket/manageList'
import addTicket from '../page/ticket/addTicket'
import ticketLists from '../page/ticket/ticketLists'
import distribution from '../page/ticket/distribution'
import distributionList from '../page/ticket/distributionList'
import voucherLog from '../page/ticket/voucherLog'

// setting
import SettingBasic from '../page/setting/Basic'
import explain from '../page/setting/explain'
import message from '../page/setting/message'
import orderDetails from '../page/setting/orderDetails'

//system => permission
import permission from '../page/system/permission'
import addAccount from '../page/system/addAccount'
import type from '../page/system/type'
import addtypes from '../page/system/addtypes'
import editType from '../page/system/editType'
import location from '../page/system/location'
import addLocation from '../page/system/addLocation'
import editLocation from '../page/system/editLocation'
import price from '../page/system/price'
import addPrice from '../page/system/addPrice'
import editPrice from '../page/system/editPrice'
import orderTime from '../page/system/orderTime'
import addOrderDiscount from '@/page/system/addOrderDiscount'
import editOrderTime from '../page/system/editOrderTime'



//reports => payment
import payment from '../page/reports/payment'
import voucherStatus from '../page/reports/voucherStatus'
import movement from '../page/reports/movement'
import saleSummary from '../page/reports/saleSummary'
import saleDetails from '../page/reports/saleDetails'
import inventory from '../page/reports/inventory'
import orderSummary from '../page/reports/orderSummary'
// import writeOff from '../page/reports/writeOff'

//market
import active from '../page/market/active'
import activeList from '../page/market/activeList'
import sales from '../page/market/sales'
import salesList from '../page/market/salesList'
import verification from '../page/market/verification'
import verificationList from '../page/market/verificationList'
import adjust from '../page/market/adjust'
import adjustList from '../page/market/adjustList'
import verify from '../page/market/verify'
import adjustment from '../page/market/adjustment'
import adjustmentStock from '../page/market/adjustmentStock'

//准备动态添加的路由
const dynamicRoutes = [
    {
        path: '/login',
        component: Login,
        name: '登录',
        iconCls: '',
        hidden: true,
    },
    {
        path: '/',
        component: Index,
        id:1,
        name: '券号管理',
        iconCls: 'iconfont icon-manage_fill',
        hidden: false,
        children: [
            { path: '/', component: Console, name: '生成', hidden: false ,id:6},
            { path: '/ticket/manageList', component: manageList,  name: '确认', hidden: false ,id:35},
            { path: '/ticket/distributionList', component: distributionList,  name: '分配', hidden: false ,id:7},
            { path: '/ticket/manage', component: manage,  name: '确认', hidden: true ,id:33},
            { path: '/ticket/distribution', component: distribution,  name: '分配', hidden: true ,id:32},
            { path: '/ticket/voucherLog', component: voucherLog,  name: '券码', hidden: true ,id:34},
            { path: '/ticket/addTicket', component: addTicket,  name: '生成券号', hidden: true ,id:22},
            { path: '/ticket/ticketLists', component: ticketLists,  name: '码库', hidden: true ,id:23},
            // { path: '/market/active', component: active,  name: '激活券号', hidden: false ,id : 36},
            // { path: '/market/sales', component: sales,  name: '销售券号', hidden: false ,id : 37},
            // { path: '/market/verification', component: verification, name: '核销券号', hidden: false,id:38 },
            // { path: '/market/adjust', component: adjust, name: '调整券号', hidden: false,id:42 },
        ]
    },
    {
        path: '/',
        component: Index,
        id:2,
        name: '销售管理',
        iconCls: 'iconfont icon-news',//图标样式class
        hidden: false,
        children: [
         { path: '/market/active', component: active,  name: '激活', hidden: false ,id : 43},
         { path: '/market/activeList', component: activeList,  name: '激活', hidden: false ,id : 36},
         { path: '/market/sales', component: sales,  name: '销售', hidden: false ,id : 46},
         { path: '/market/salesList', component: salesList,  name: '销售', hidden: false ,id : 37},
         { path: '/market/verification', component: verification, name: '核销', hidden: false,id:45 },
         { path: '/market/verificationList', component: verificationList, name: '核销', hidden: false,id:38 },
         { path: '/market/adjust', component: adjust, name: '调整', hidden: false,id:44 },
         { path: '/market/adjustList', component: adjustList, name: '调整', hidden: false,id:42 },
         { path: '/market/verify', component: verify, name: '校验', hidden: false,id:39 }
        ]
    },
    {
        path: '/',
        component: Index,
        id:10,
        name: '库存管理',
        iconCls: 'iconfont icon-activity_fill',
        hidden: false,
        children: [
            { path: '/market/adjustment', component: adjustment, name: '调整库存', hidden: false ,id:49},
            { path: '/market/adjustmentStock', component: adjustmentStock, name: '调整库存', hidden: true ,id:50},
            { path: '/setting/explain', component: explain, name: '说明', hidden: true,id:21 },
        ]
    },
    {
        path: '/',
        component: Index,
        id:3,
        name: '报表',
        iconCls: 'iconfont icon-tongji',
        hidden: false,
        children: [
            { path: '/reports/payment', component: payment, name: '结算报表', hidden: false ,id:12},
            { path: '/reports/voucherStatus', component: voucherStatus, name: '券号状态', hidden: false,id:13 },  
            { path: '/reports/movement', component: movement, name: '操作流程', hidden: false,id:14 },  
            { path: '/reports/saleSummary', component: saleSummary, name: '销售摘要', hidden: false,id:47 },  
            { path: '/reports/saleDetails', component: saleDetails, name: '销售详情', hidden: false,id:48 },  
            { path: '/reports/inventory', component: inventory, name: '库存详情', hidden: false,id:51 },  
            { path: '/setting/message', component: message, name: '订单查询', hidden: false,id:22 },
            { path: '/setting/orderDetails', component: orderDetails, name: '订单详情', hidden: true,id:66 },
            // { path: '/setting/orderSummary', component: orderSummary, name: '订单摘要', hidden: false,id:52 },
            // { path: '/reports/writeOff', component: writeOff, name: '核销查询', hidden: false,id:52 },  
        ]
    },
    
    {
        path: '/',
        component: Index,
        id:4,
        name: '系统管理',
        iconCls: 'iconfont icon-users',
        hidden: false,
        children: [
            { 
                path: '/system/permission',component:permission,name:'用户管理',hidden:false,id:15,
                children:[
                    //{path:'/system/addAccount',component:addAccount,name:'修改账号',hidden:true}
                ]
            },
            // { path: '/system/logList',component:logList,name:'操作日志',hidden:false, id:16},
            { path: '/system/addAccount',component:addAccount,name:'添加账户',hidden:true,id:17},
            { path: '/system/delAccount',component:addAccount,name:'修改账号',hidden:true,id:18},
            { path: '/system/rePass',component:addAccount,name:'修改密码',hidden:true ,id:19},
            { path: '/system/type',component:type,name:'产品类型',hidden : false ,id : 24},
            { path: '/system/addtypes',component:addtypes,name:'添加产品类型',hidden : true ,id : 25},
            { path: '/system/editType',component:addtypes,name:'修改产品类型',hidden : true ,id : 29},
            { path: '/system/location',component:location,name:'销售地点',hidden : false ,id : 16},
            { path: '/system/addLocation',component:addLocation,name:'添加销售地点',hidden : true ,id : 26},
            { path: '/system/editLocation',component:addLocation,name:'修改销售地点',hidden : true ,id : 30},
            { path: '/system/price',component:price,name:'产品价格',hidden : false ,id : 27},
            { path: '/system/addPrice',component:addPrice,name:'添加商品价格',hidden : true },
            { path: '/system/editPrice',component:addPrice,name:'修改商品价格',hidden : true ,id : 31},
            { path: '/system/orderTime',component:orderTime,name:'订单时间',hidden : false ,id : 28},
            { path: '/system/orderDiscount',component:addOrderDiscount,name:'订单优惠',hidden : false ,id : 29},
            { path: '/system/editOrderTime',component:editOrderTime,name:'修改订单时间',hidden : false ,id : 60},

        ]
    },
    {
        path: '/',
        component: Index,
        id:5,
        name: '设置',
        iconCls: 'iconfont icon-kongzhitai',
        hidden: false,
        children: [
            { path: '/setting/basic', component: SettingBasic, name: '个人中心', hidden: false ,id:20},
            { path: '/setting/explain', component: explain, name: '说明', hidden: true,id:21 },
            
        ]
    },
]
const router = new VueRouter({
    //mode: 'history',  //去掉url中的#
    mode : 'hash',
    routes : dynamicRoutes
})

/**
 * 路由拦截的判断
 * 1，如果没有Token就会进入login页面
 */

router.beforeEach((to, from, next) => {
    // console.log( to );
    //如果没有Token跳转Login页面
    let Token = sessionStorage.getItem('Token');

    if( Token == null ){
        if( to.path == '/login'){
            next();
        }else{
            next({ path: '/login' })
        }
    }else{
        if( to.path == '/login' ){
            let treeId = JSON.parse(sessionStorage.getItem('treeId'));
            getAuthRouter(treeId).then(( res )=>{
                router.options.routes = res;
                //console.log(res) //[]
                if( res[0].hasOwnProperty('children') && res[0].children.length > 0 ){
                    next({path : res[0].children[0].path });
                    return;
                }
                next({path : res[0].path });
            })
        }else{
            let treeId = JSON.parse(sessionStorage.getItem('treeId'));
            getAuthRouter(treeId).then(( res )=>{
                router.options.routes = res;
                next()
            })
        }
    }
});

//这里是我们写好的需要权限判断的路由,所有路由的集合
//  let treeId = JSON.parse(sessionStorage.getItem('treeId'));
//  console.log(treeId)
//let treeId =[1,6,2,7,8,9,10,3,11,12,13,4,14,15,16,17,18,5,19,20];
function getAuthRouter(treeId){
	return new Promise((resolve)=>{
		let list = [];
		dynamicRoutes.forEach(( val, key )=>{
			treeId.forEach(( v, k )=>{
				if( v == val.id ){
					list.push(val);
					treeId.splice(k,1)
				}
			})
		})
		
		list.forEach((val,key)=>{
			let children = [];
			treeId.forEach(( v, k )=>{
				val.children.forEach((a,b)=>{
					if( a.id == v ){
						children.push( a );
					}
				})
			})
			val.children = children;
		})
		resolve( list);
		
	})
}
// getAuthRouter().then((res)=>{
//     console.log( res )
//     router.options.routes.push(...res);  
// })


export default router;